import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import styled from '@mui/material/styles/styled';
import { DRAWER_INDEX } from '@/features/drawer/constants/drawerIndex';
import { DrawerSize } from '@/features/drawer/enums/DrawerSize';
import { DrawerStatus } from '@/features/drawer/enums/DrawerStatus';
import StyleService from '@/services/StyleService/StyleService';

export const BaseDrawerStyled = styled(Drawer, {
  shouldForwardProp: StyleService.shouldNotForwardProps(['_status', 'offsetRight', 'size', 'zIndex']),
})<{
  zIndex: number;
  status: DrawerStatus;
  offsetRight: number | string;
  size: DrawerSize;
}>(({ zIndex = DRAWER_INDEX, offsetRight = 0, size = DrawerSize.Normal, status }) => {
  return {
    zIndex,
    pointerEvents: 'none',
    '& > .MuiDrawer-paper': {
      pointerEvents: status !== DrawerStatus.Showed ? 'none' : 'all',
      top: 0,
      right: status === DrawerStatus.Hidden ? '-100vw' : 0,
      justifyContent: 'flex-end',
      transitionProperty: 'right',
      overflowY: 'initial',
      background: 'transparent',
      boxShadow: 'none',
      border: 'none',
      transition: 'width 0.3s ease, right 0.3s ease',
      width: size,
      marginRight: isNaN(Number(offsetRight)) ? offsetRight : `${offsetRight}px`,
      zIndex,
    },
  };
});

export const BaseDrawerBodyWrapper = styled(Stack, {
  shouldForwardProp: StyleService.shouldNotForwardProps(['offsetTop', 'background']),
})<{ size: DrawerSize; offsetTop: number; background?: string }>(({ background, offsetTop, theme }) => {
  return {
    background: background || theme.palette.background.secondary,
    height: `calc(100% - ${offsetTop}px)`,
    boxShadow: '0px 8px 16px 2px rgba(0, 0, 0, 0.16)',
    position: 'relative',
    overflowY: 'auto',
  };
});
